import { Flex, IconInfo, Tooltip } from '@gmg/gmg-react-components';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ModuleLicense } from 'src/viewModels/Organization';
import styled from 'styled-components';
import ProductRow from './ProductRow';

export interface ProductManagementTableProps {
    productList: Array<ModuleLicense>;
};

const ProductsTable: FunctionComponent<ProductManagementTableProps> = (props) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <Container aria-label="Product list" className="vertical-scrollbar">
                <Header className="px12_600_normal">
                    <Flex role='columnheader'>
                        {t('ProductManagementTable.columns.product_title', 'Product')}
                    </Flex>
                    <div role='columnheader'>
                        {t('ProductManagementTable.columns.product_type_title', 'Type')}
                    </div>
                    <Flex gap='4px'>
                        {t('ProductManagementTable.columns.availability_title', 'Availability')}
                        <Tooltip message={t('ProductManagementTable.columns.availability_tooltip', 'Shows available seats or cards. Manage assignments in Users by editing a user.')}>
                            <Flex alignItems='center'>
                                <IconInfo width={12} height={12} />
                            </Flex>
                        </Tooltip>
                    </Flex>
                    <div role='columnheader'>
                        {t('ProductManagementTable.columns.validity_title', 'Validity')}
                    </div>
                </Header>

                <Flex flexDirection='column' gap='16px'>
                    {props.productList.map(product => <ProductRow key={product.name} product={product} />)}
                </Flex>
            </Container>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: var(--table-card-padding);
    min-width: 100%;

    background-color: ${props => props.theme.colors.backgroundPaper};
`;

const Container = styled.div`
    max-width: var(--product-table-width);
    height: var(--card-style-table-max-height);

    background-color: ${props => props.theme.colors.background};
    position: relative;
    overflow-x: hidden;
    border-radius: 8px;
    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.10);
    padding: 0 var(--table-card-padding);
`;
const Header = styled.div`
    position: sticky;
    top: 0;
    display: grid;
    grid-template-columns: repeat(7, var(--product-table-grid-column-width));
    align-items: center;
    height: var(--table-row-height);
    padding-left: 20px;
    background-color: ${props => props.theme.colors.background};
    box-sizing: border-box;
    z-index: 10;
`;

export default ProductsTable;
